import { ComponentFactory, Injectable } from '@angular/core';
import { ThemeComponentsMap } from '@core/configs/lazy-loader.config';
import { Theme } from '@core/enums/theme.enum';
import { Observable, ReplaySubject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { LazyLoaderService } from '../lazy-loader/lazy-loader.service';

/**
 * {@link} https://coryrylan.com/blog/theming-angular-apps-with-css-custom-properties
 */
@Injectable()
export class ThemeService {

  readonly currentTheme = new ReplaySubject<ComponentFactory<any>>(1);

  constructor(
    private configService: ConfigService,
    private lazyLoaderService: LazyLoaderService
  ) { }

  private loadTheme(theme: Theme): Observable<ComponentFactory<any>> {
    return this.lazyLoaderService.loadComponent(ThemeComponentsMap[theme])
      .pipe(
        take(1),
        tap(componentFactory => this.currentTheme.next(componentFactory)),
      );
  }

  initTheme(): Observable<ComponentFactory<any>> {
    return this.loadTheme(this.configService.siteConfig.theme);
  }

}
